import { OrePill, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { invoicesState } from '@/Invoices/domain'
import { invoicesTranslation } from '@/Invoices/ui/invoicesTranslation'

interface IProps {
  state: number
}

export const PillState = ({ state }: IProps): JSX.Element => {
  const { t } = useTranslation()

  const colorPill =
    state === invoicesState.paid
      ? 'success-600'
      : state === invoicesState.pending
        ? 'warning-600'
        : undefined
  const textPill =
    state === invoicesState.paid
      ? t(invoicesTranslation.table.body.state.paid)
      : state === invoicesState.pending
        ? t(invoicesTranslation.table.body.state.pending)
        : undefined

  return (
    <OrePill tone={colorPill}>
      <OreText size="text-sm" tone={colorPill} nowrap>
        {textPill}
      </OreText>
    </OrePill>
  )
}
